import type { SimpleChanges } from '@angular/core';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { CatalogRow } from '@app/services/catalogo/models';

type KanbanColKey = 'PEND_IMPORT' | 'IMPORT' | 'IMPORT_FAILED' | 'TO_PUBLISH' | 'PUBLISH_SCHEDULED' | 'PUBLISHED';

interface KanbanCol {
  key: KanbanColKey;
  title: string;
  icon?: string;
  hintColor?: string;
}

@Component({ standalone: false, selector: 'app-catalog-kanban',
  templateUrl: './catalog-kanban.component.html',
  styleUrls: ['./catalog-kanban.component.scss']
})
export class CatalogKanbanComponent {
  @Input() rows: CatalogRow[] = [];
  @Input() cols: KanbanCol[] = [];
  @Input() data!: Record<string, CatalogRow[]>;
  @Input() showProvider = true;
  @Input() showDates = true;
  @Input() showQuickActions = true;
  @Input() allowedTransitions: {
    PEND_IMPORT: string[];
    IMPORT_FAILED: string[];
    TO_PUBLISH: string[];
    PUBLISHED: string[]
  } = {
    PEND_IMPORT: ['TO_PUBLISH', 'IMPORT_FAILED'],
    IMPORT_FAILED: ['PEND_IMPORT'],
    TO_PUBLISH: ['PUBLISHED', 'IMPORT_FAILED'],
    PUBLISHED: []
  };

  // popover de asignaciones (usa plantilla del PADRE)
  @Input() assignTpl!: any;

  // callbacks
  @Output() drop = new EventEmitter<{ event: CdkDragDrop<CatalogRow[]>, target: KanbanColKey }>();
  @Output() clickAssign = new EventEmitter<CatalogRow>();
  @Output() clickEdit = new EventEmitter<CatalogRow>();
  @Output() stateChange = new EventEmitter<{ row: CatalogRow; from: KanbanColKey; to: KanbanColKey; index: number }>();

  trackByColumn = (index: number, col: KanbanCol): string | number => col?.key ?? index;
  trackByRow = (index: number, row: CatalogRow): string | number => row?.id ?? index;

  // para título/estilo de estado puedes seguir usando pipes/clases del padre si hiciera falta
  ngOnChanges(changes: SimpleChanges) {
    if (changes.rows) {
      this.data = {};
      for (const col of this.cols) {
        this.data[col.key] = [];
      }
      for (const r of this.rows || []) {
        const rowsByState = this.data[r.state] || (this.data[r.state] = []);
        rowsByState.push(r);
      }
    }
  }

  handleDrop(ev: CdkDragDrop<CatalogRow[]>, to: KanbanColKey) {
    const from = ev.previousContainer.id as KanbanColKey; // en el HTML usas [id]="col.key"
    const index = ev.currentIndex;

    // si marcas el drag data, perfecto; si no, caemos al elemento por índice
    const dragged: CatalogRow | undefined =
      (ev.item as any).data ?? ev.container.data?.[index];

    if (dragged) {
      this.stateChange.emit({ row: dragged, from, to, index });
    }

    // (opcional) si quieres mantener el evento “bruto”:
    this.drop.emit({ event: ev, target: to });
  }
}
